import {
  Box,
  Grid,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";

const COLUMN_COUNT = 9; // adjust if table layout changes
const ROW_COUNT = 14;

const ReceiptsSkeleton = () => {
  const rows = Array.from({ length: ROW_COUNT });
  const columns = Array.from({ length: COLUMN_COUNT });

  return (
    <>
      <Box sx={{ padding: "16px" }}>
        <Grid container rowSpacing={2} columnSpacing={2} mb={2}>
          <Grid item xs={9}>
            <Skeleton variant="text" width={200} height={32} sx={{ mb: 1 }} />
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rectangular" width={100} height={36} />
              <Skeleton variant="rectangular" width={100} height={36} />
              <Skeleton variant="rectangular" width={130} height={36} />
            </Stack>
          </Grid>
          <Grid item xs={3}>
            <Skeleton variant="rectangular" height={70} />
          </Grid>
        </Grid>

        <Grid container rowSpacing={2} columnSpacing={3} alignItems="center">
          <Grid item xs={3}>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Grid>
          <Grid item xs={7}>
            <Skeleton variant="text" width={250} height={26} />
          </Grid>
          <Grid item xs={2}>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="circular" width={40} height={40} />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <TableContainer className="receiptsTable receiptsMainTable">
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((_, index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    <Skeleton width="60%" />
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell align="center">
                <TableSortLabel>
                  <Skeleton width={80} />
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  "& > *": {
                    borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                  },
                }}
              >
                {columns.map((_, cellIndex) => (
                  <TableCell key={cellIndex} align="left">
                    <Skeleton variant="text" width="80%" />
                  </TableCell>
                ))}
                <TableCell align="center">
                  <Skeleton
                    variant="rectangular"
                    width={100}
                    height={30}
                    sx={{ margin: "auto", borderRadius: 1 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReceiptsSkeleton;
